import { z } from 'zod';

export const settingsGeneralSchema = z.object({
  workspaceName: z.string()
    .trim()
    .min(1, 'El nombre del espacio de trabajo es requerido')
    .max(100, 'El nombre del espacio de trabajo no puede exceder 100 caracteres'),
  email: z.string()
    .trim()
    .email('Email inválido')
    .max(255, 'El email no puede exceder 255 caracteres')
    .optional()
    .or(z.literal('')),
});

export const settingsPreferencesSchema = z.object({
  realtimeUpdates: z.boolean(),
  emailAlerts: z.boolean(),
  dataExport: z.boolean(),
});

export const companySettingsSchema = z.object({
  company_name: z.string()
    .min(1, 'El nombre de la empresa es requerido')
    .max(255, 'El nombre de la empresa debe tener máximo 255 caracteres'),
  business_name: z.string()
    .max(255, 'La razón social debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  commercial: z.string()
    .max(255, 'El nombre comercial debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  aux_title: z.string()
    .max(255, 'El título auxiliar debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  address: z.string()
    .max(500, 'La dirección debe tener máximo 500 caracteres')
    .optional()
    .or(z.literal('')),
  phone: z.string()
    .max(50, 'El teléfono debe tener máximo 50 caracteres')
    .optional()
    .or(z.literal('')),
  email: z.string()
    .email('Debe ser un email válido')
    .max(100, 'El email debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  logo_url: z.string()
    .url('Debe ser una URL válida')
    .max(500, 'La URL del logo debe tener máximo 500 caracteres')
    .optional()
    .or(z.literal('')),
});

export type SettingsGeneralInput = z.infer<typeof settingsGeneralSchema>;
export type SettingsPreferencesInput = z.infer<typeof settingsPreferencesSchema>;
export type CompanySettingsInput = z.infer<typeof companySettingsSchema>;
